import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default (state = initialState.loadingVoucherType, { type }) => {
  switch (type) {
    case types.BEGIN_LOAD_VOUCHER_TYPE:
      return true;
    case types.LOAD_VOUCHER_TYPE_SUCCESS:
    case types.LOAD_VOUCHER_TYPE_FAILURE:
      return false;

    default:
      return state;
  }
};
